import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { LiveAlertMessage } from '../showcase.model';
import { ShowcaseService } from '../showcase.service';
import { ShowcaseTrackingService } from '../showcase.tracking.service';

@Component({
    selector: 'ms-live-alert-item',
    templateUrl: 'live-alert-item.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveAlertItemComponent {
    @Input() alert: LiveAlertMessage;
    @HostBinding('class') className = 'alert-message';
    constructor(
        private showcaseService: ShowcaseService,
        private showcaseTrackingService: ShowcaseTrackingService,
    ) {}

    goto(liveAlertMessage: LiveAlertMessage, event: Event): void {
        this.showcaseService.eventSelectedFromTabBar = false;
        event.stopPropagation();
        this.showcaseService.select(liveAlertMessage.eventId);
        this.showcaseService.selectAlert();
        this.showcaseTrackingService.trackGameAlertsEventRedirecting(liveAlertMessage);
    }
}
